import updateLocale from "dayjs/plugin/updateLocale";
import dayjs from "dayjs";
import "dayjs/locale/nl";

export const WcSetDefaultLocale = (inputWeekStart?: number) => {
  const defaultStartWeek = inputWeekStart || 0;
  dayjs.locale("nl");

  dayjs.extend(updateLocale);
  dayjs.updateLocale("nl", {
    weekStart: defaultStartWeek,
  });
};
